import { SnackbarType } from 'common/interfaces';
import UILogger from 'common/utils/logger';
import { useAppDispatch } from 'setup/store';
import { useAppActions } from './app-actions';
import { DayReportActions } from 'reducers/day-report-reducer';
import { UpdateSalesEntryActions } from 'reducers/sales/update-sales-reducer';
import { IGasReport } from 'common/interfaces/iGasReport';
import { getGasReportByDayReportId, postUpsertGasReport } from 'services/gas-report-service';
import { useTranslation } from 'react-i18next';

export const useGasReportEntryActions = () => {
  const dispatch = useAppDispatch();
  const { showSnackBar } = useAppActions();
  const { t } = useTranslation();

  const setLoading = async (isLoading: boolean) => {
    dispatch(DayReportActions.setLoading(isLoading));
  };

  const updateGasReportEntry = async (payload: IGasReport) => {
    setLoading(true);
    dispatch(DayReportActions.setError(null));
    resetUpdatedData();

    let resp = await postUpsertGasReport(payload);

    console.log('updateGasReportEntry.....', resp);
    setLoading(false);
    if (resp && resp.status.success) {
      dispatch(DayReportActions.setDataUpdated({ type: 'gas', isUpdated: true }));
      return true;
    } else {
      dispatch(DayReportActions.setDataUpdated({ type: 'gas', isUpdated: false }));
      const msg = resp?.status?.msg || t('error.updateSalesEntry') || '';
      console.log('updateGasReportEntry. setError.....', msg);
      dispatch(DayReportActions.setError({ code: '', msg }));
    }
    return false;
  };

  const loadGasReportEntry = async (reportId: number) => {
    setLoading(true);
    let resp = await getGasReportByDayReportId(reportId);
    setLoading(false);
    if (resp?.status?.success) {
      dispatch(
        UpdateSalesEntryActions.setAttachments({
          type: 'dayGasReport',
          attachments: resp.attachments,
        }),
      );
      return resp.data;
    } else {
      UILogger.error('Could not load day gas report entry details. by report Id: ', reportId);
      showSnackBar(SnackbarType.ERROR, 'Could not load gas report details.');
    }
  };

  const resetUpdatedData = () => {
    dispatch(DayReportActions.resetDataUpdated());
  };

  return {
    setLoading,
    updateGasReportEntry,
    loadGasReportEntry,
    resetUpdatedData,
  };
};
